import { Address, Client } from "@domain/models/Client";
import { ClientImportHeader } from "@domain/models/ClientImportHeader";

export const importCsvModel: {
  field:
    | keyof Client
    | keyof Address
    | keyof Client["phones"]
    | keyof Client["telephone"]
    | keyof Client["rejection"];
  headerName: keyof ClientImportHeader;
}[] = [
  {
    field: "cpf",
    headerName: "CPF",
  },
  {
    field: "name",
    headerName: "NOME",
  },
  {
    field: "birthDate",
    headerName: "DATA DE NASCIMENTO",
  },
  {
    field: "age",
    headerName: "IDADE",
  },
  {
    field: "nb",
    headerName: "NB",
  },
  {
    field: "date",
    headerName: "DATA DE INDEFERIMENTO",
  },
  {
    field: "specie",
    headerName: "ESPECIE",
  },
  {
    field: "reason",
    headerName: "MOTIVO DO INDEFERIMENTO",
  },
  {
    field: "motherName",
    headerName: "NOME_MAE",
  },
  {
    field: "street",
    headerName: "LOGRADOURO S1",
  },
  {
    field: "number",
    headerName: "NUMERO S1",
  },
  {
    field: "complement",
    headerName: "COMPLEMENTO S1",
  },
  {
    field: "district",
    headerName: "BAIRRO S1",
  },
  {
    field: "cityMap",
    headerName: "ESTADO-CIDADE S1",
  },
  {
    field: "state",
    headerName: "ESTADO S1",
  },
  {
    field: "city",
    headerName: "CIDADE S1",
  },
  {
    field: "zipCode",
    headerName: "CEP S1",
  },
  {
    field: "street",
    headerName: "LOGRADOURO S2",
  },
  {
    field: "number",
    headerName: "NUMERO S2",
  },
  {
    field: "complement",
    headerName: "COMPLEMENTO S2",
  },
  {
    field: "district",
    headerName: "BAIRRO S2",
  },
  {
    field: "cityMap",
    headerName: "ESTADO-CIDADE S2",
  },
  {
    field: "state",
    headerName: "ESTADO S2",
  },
  {
    field: "city",
    headerName: "CIDADE S2",
  },
  {
    field: "zipCode",
    headerName: "CEP S2",
  },
  {
    field: "street",
    headerName: "LOGRADOURO O1",
  },
  {
    field: "number",
    headerName: "NUMERO O1",
  },
  {
    field: "complement",
    headerName: "COMPLEMENTO O1",
  },
  {
    field: "district",
    headerName: "BAIRRO O1",
  },
  {
    field: "cityMap",
    headerName: "ESTADO-CIDADE O1",
  },
  {
    field: "state",
    headerName: "ESTADO O1",
  },
  {
    field: "city",
    headerName: "CIDADE O1",
  },
  {
    field: "zipCode",
    headerName: "CEP O1",
  },
  {
    field: "street",
    headerName: "LOGRADOURO O2",
  },
  {
    field: "number",
    headerName: "NUMERO O2",
  },
  {
    field: "complement",
    headerName: "COMPLEMENTO O2",
  },
  {
    field: "district",
    headerName: "BAIRRO O2",
  },
  {
    field: "cityMap",
    headerName: "ESTADO-CIDADE O2",
  },
  {
    field: "state",
    headerName: "ESTADO O2",
  },
  {
    field: "city",
    headerName: "CIDADE O2",
  },
  {
    field: "zipCode",
    headerName: "CEP O2",
  },
  {
    field: "phone",
    headerName: "CELULAR",
  },
  {
    field: "primary",
    headerName: "TELEFONE PRINCIPAL",
  },
  {
    field: "secondary",
    headerName: "TELEFONE SECUNDARIO",
  },
  {
    field: "0",
    headerName: "CELULAR0",
  },
  {
    field: "1",
    headerName: "CELULAR1",
  },
  {
    field: "2",
    headerName: "CELULAR2",
  },
  {
    field: "0",
    headerName: "TELEFONE0",
  },
  {
    field: "1",
    headerName: "TELEFONE1",
  },
  {
    field: "2",
    headerName: "TELEFONE2",
  },
  {
    field: "email",
    headerName: "E-MAIL",
  },
  {
    field: "processes",
    headerName: "PROCESSOS",
  },
  {
    field: "derDate",
    headerName: "DATA DA DER",
  },
  {
    field: "analysis",
    headerName: "ANALISE",
  },
];
